import { p as proxyCustomElement, H, c as createEvent, h } from './p-d7c3b756.js';
import { get, isEqual } from 'lodash-es';
import moment from 'moment';
import { d as defineCustomElement$4 } from './p-6c17fe8d.js';
import { d as defineCustomElement$3 } from './p-e02a2c19.js';
import { d as defineCustomElement$2 } from './p-4c1b8a2d.js';
import { d as defineCustomElement$1 } from './p-6a1cffde.js';
import { B as BxfDatePickerDateFormatEnum, a as BxfDatePickerSeparatorsEnum } from './p-0cccf823.js';
import { S as SPACE_REGEX, B as BxfCalendarConstants } from './p-c40beb29.js';
import { B as BxfCalendarSettingsConstants } from './p-597e8968.js';
import { u as uuidv4 } from './p-2b83a1d1.js';
import { P as eventPath, l as createSelector } from './p-0856cfca.js';
import { B as BxfSelectConstants } from './p-2c52f7ab.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './p-01256821.js';

const bxfCalendarSettingsCss = "button.sc-bxf-calendar-settings:hover,a.sc-bxf-calendar-settings:hover,input[type=radio].sc-bxf-calendar-settings:hover,input[type=checkbox].sc-bxf-calendar-settings:hover,input[type=radio].sc-bxf-calendar-settings:checked:hover,input[type=checkbox].sc-bxf-calendar-settings:checked:hover,svg.sc-bxf-calendar-settings:hover{cursor:pointer}svg[disabled].sc-bxf-calendar-settings:hover,button[disabled].sc-bxf-calendar-settings:hover,label[disabled].sc-bxf-calendar-settings:hover,input[type=checkbox].sc-bxf-calendar-settings:disabled:hover,input[type=radio].sc-bxf-calendar-settings:disabled:hover,input[type=checkbox].sc-bxf-calendar-settings:checked:disabled:hover,input[type=radio].sc-bxf-calendar-settings:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-calendar-settings{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-calendar-settings__container.sc-bxf-calendar-settings{display:block;padding:1.25rem 1.25rem 1.5rem;border:1px solid var(--calendar__border-color--menu);border-bottom:1px solid var(--primary-action__color);border-radius:0.125rem;box-sizing:border-box;background-color:var(--widget__background-color);box-shadow:0 0.25rem 0.75rem 0 var(--elevation__box-shadow-color);font-size:0.8125rem;overflow-y:hidden;color:var(--primary-text__color)}.bxf-calendar-settings__container.sc-bxf-calendar-settings:focus{outline:none}.bxf-calendar-settings__calendars.sc-bxf-calendar-settings{margin-right:1.25rem;margin-bottom:1.5rem;width:7.75rem;height:2rem;outline:none}";
const BxfCalendarSettingsStyle0 = bxfCalendarSettingsCss;

const { CALENDAR_LABEL, CALENDARS_BOX, SETTINGS_LABEL, RADIO_LABEL, SETTINGS_CONTAINER, DEFAULT_US, SEPARATOR_LABEL, DIALOG, } = BxfCalendarConstants.STRING;
const { DEFAULT_DAY, DEFAULT_MONTH } = BxfCalendarSettingsConstants.STRING;
const BxfCalendarSettings = /*@__PURE__*/ proxyCustomElement(class BxfCalendarSettings extends H {
    _dateFormatRadioData;
    separatorOptions;
    CALENDARS_BXF_ID = uuidv4();
    SEPARATORS_BXF_ID = uuidv4();
    i18n;
    get host() { return this; }
    /**
     * @internal
     * This event is emitted when settings panel is rendered
     */
    calendarSettingsConnected;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted when a separator is selected in settings panel
     */
    separatorSelected;
    /**
     * This event is emitted when date format is selected in settings panel
     */
    dateFormatSelected;
    selectionChangedHandler(event) {
        const select = eventPath(event).find((elm) => elm.nodeName === BxfSelectConstants.COMPONENT_NAME.toUpperCase());
        const bxfId = get(select, 'dataset.bxfId');
        if (bxfId === this.CALENDARS_BXF_ID) {
            this.calendarSelectionHandler(event);
        }
        else if (bxfId === this.SEPARATORS_BXF_ID) {
            this.separatorSelectionHandler(event);
        }
    }
    separatorChangedHandler() {
        this.updateSettings();
    }
    dateFormatChangedHandler() {
        this.updateSettings();
    }
    /**
     * Update activeCalendar state when settingsSelectData dynamically changed
     */
    settingsSelectDataChangedHandler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
            this.updateActiveCalendar(newValue);
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.calendarSettingsConnected = createEvent(this, "calendarSettingsConnected", 7);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.separatorSelected = createEvent(this, "separatorSelected", 7);
        this.dateFormatSelected = createEvent(this, "dateFormatSelected", 7);
        this.isSettingsVisible = false;
        this.dateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
        this.displayDateFormat = BxfDatePickerDateFormatEnum.DD_MMM_YYYY;
        this.separator = BxfDatePickerSeparatorsEnum.DASH;
        this.lastSelectedDay = undefined;
        this.eventData = {};
        this.calendarHeight = 'auto';
        this.settingsSelectData = [];
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.hasSeparatorSettings = true;
        this.hasDateFormatSettings = true;
        this.keepMouseFocus = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.activeCalendar = DEFAULT_US;
        this.radioLabel = RADIO_LABEL;
        this.settingsLabel = SETTINGS_LABEL;
        this.calendarLabel = CALENDAR_LABEL;
        this.separatorLabel = SEPARATOR_LABEL;
        this.dateFormatRadioDataChangedHandler =
            this.dateFormatRadioDataChangedHandler.bind(this);
    }
    componentWillLoad() {
        this._dateFormatRadioData = Object.keys(BxfDatePickerDateFormatEnum).map((dateFormat) => {
            return {
                label: this.getFormattedDate(dateFormat),
                secondaryLabel: `(${dateFormat.replace(/_/g, this.separator)})`,
                checked: this.displayDateFormat === this.dateFormat &&
                    this.dateFormat ===
                        dateFormat.replace(/_/g, BxfDatePickerSeparatorsEnum.SPACE),
                disabled: false,
                eventData: dateFormat,
            };
        });
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.updateActiveCalendar(this.settingsSelectData);
        this.separatorOptions = [
            {
                values: [
                    ...Object.entries(BxfDatePickerSeparatorsEnum).map((entry) => {
                        const v = entry[0].replace(/_/g, ' ');
                        return {
                            value: entry[0],
                            displayValue: `${v.charAt(0).toUpperCase() +
                                v.substring(1).toLowerCase()} ${entry[1] ===
                                BxfDatePickerSeparatorsEnum.SPACE
                                ? ''
                                : `( ${entry[1]} )`}`.trim(),
                            isSelected: entry[1] === this.separator,
                        };
                    }),
                ],
            },
        ];
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    componentDidRender() {
        if (this.isSettingsVisible) {
            this.calendarSettingsConnected.emit({ host: this.host });
        }
    }
    disconnectedCallback() {
        this.i18n?.destroyTranslations();
    }
    /**
     * Update active calendar based on selection from settingsSelectData
     */
    updateActiveCalendar(settingsSelectData) {
        /* istanbul ignore else */
        if (settingsSelectData?.length) {
            const index = settingsSelectData.findIndex((data) => data.isSelected);
            this.activeCalendar = settingsSelectData[index].value.calendar;
        }
    }
    updateSettings() {
        this.separatorOptions[0].values?.forEach((data) => (data.isSelected =
            this.separator === BxfDatePickerSeparatorsEnum[data.value]));
        const temp = [...this._dateFormatRadioData];
        temp.forEach((data) => {
            const dateFormat = BxfDatePickerDateFormatEnum[data.eventData];
            data.label = this.getFormattedDate(dateFormat);
            data.secondaryLabel = `(${dateFormat.replace(SPACE_REGEX, this.separator)})`;
            data.checked =
                this.displayDateFormat === this.dateFormat &&
                    this.dateFormat ===
                        dateFormat.replace(/_/g, BxfDatePickerSeparatorsEnum.SPACE);
        });
        this._dateFormatRadioData = temp;
    }
    getFormattedDate(dateFormat) {
        const defaultDateMoment = moment()
            .date(DEFAULT_DAY)
            .month(DEFAULT_MONTH);
        const newDateFormat = dateFormat.replace(/\s|_/g, this.separator);
        return this.lastSelectedDay
            ? moment(this.lastSelectedDay, BxfDatePickerDateFormatEnum.DD_MM_YYYY).format(newDateFormat)
            : defaultDateMoment.format(newDateFormat);
    }
    dateFormatRadioDataChangedHandler(event = {}) {
        const { detail: { value: { eventData }, }, } = event;
        const dateFormat = BxfDatePickerDateFormatEnum[eventData];
        if (dateFormat) {
            this.dateFormatSelected.emit({
                dateFormat,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    calendarSelectionHandler(event = {}) {
        const { detail: { value: { value } } = { value: { value: {} } } } = event;
        if (value.calendar && value.calendar != this.activeCalendar) {
            this.activeCalendar = value.calendar;
            this.calendarSelected.emit({
                value,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    separatorSelectionHandler(event = {}) {
        const separator = BxfDatePickerSeparatorsEnum[event.detail?.value?.value];
        if (separator !== this.separator) {
            this.separator = separator;
            this.separatorSelected.emit({
                separator,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    /**
     * Render dialog content if settings are visible.
     * NOTE: dialog wrapper needs to render first so that focus trap can
     * 	work properly, as isSettingsVisible isn't updated until updateState callback
     */
    renderDialogContents() {
        if (this.isSettingsVisible) {
            return (h("div", null, this.settingsSelectData &&
                this.settingsSelectData.length ? (h("bxf-select", { "data-bxf-id": this.CALENDARS_BXF_ID, "data-test": createSelector(this.host.tagName, this.calendarLabel), label: this.calendarLabel, isLeftLabel: true, class: CALENDARS_BOX, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, dataTestSuffix: this.dataTestSuffix, parentOverlayContainerSelector: this.parentOverlayContainerSelector, data: [
                    {
                        values: this.settingsSelectData,
                    },
                ], keepMouseFocus: this.keepMouseFocus })) : null, this.hasSeparatorSettings && (h("bxf-select", { "data-bxf-id": this.SEPARATORS_BXF_ID, "data-test": createSelector(this.host.tagName, this.separatorLabel), label: this.separatorLabel, isLeftLabel: true, class: CALENDARS_BOX, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, dataTestSuffix: this.dataTestSuffix, data: this.separatorOptions, keepMouseFocus: this.keepMouseFocus, parentOverlayContainerSelector: this.parentOverlayContainerSelector })), this.hasDateFormatSettings && (h("bxf-radio-group", { "data-test": createSelector(this.host.tagName, this.radioLabel), isStacked: true, label: this.radioLabel, dataTestSuffix: this.dataTestSuffix, data: this._dateFormatRadioData, onRadioGroupChanged: this.dateFormatRadioDataChangedHandler, keepMouseFocus: this.keepMouseFocus }))));
        }
    }
    render() {
        return (h("section", { key: '13ec001ca789b4265936bc3b54bfbaf439bab9b0', role: DIALOG, class: SETTINGS_CONTAINER, style: {
                minHeight: this.calendarHeight
                    ? `${this.calendarHeight}px`
                    : 'auto',
            }, "aria-label": this.settingsLabel, "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderDialogContents()));
    }
    static get watchers() { return {
        "separator": ["separatorChangedHandler"],
        "lastSelectedDay": ["separatorChangedHandler"],
        "dateFormat": ["dateFormatChangedHandler"],
        "displayDateFormat": ["dateFormatChangedHandler"],
        "settingsSelectData": ["settingsSelectDataChangedHandler"]
    }; }
    static get style() { return BxfCalendarSettingsStyle0; }
}, [2, "bxf-calendar-settings", {
        "isSettingsVisible": [1540, "is-settings-visible"],
        "dateFormat": [1537, "date-format"],
        "displayDateFormat": [1537, "display-date-format"],
        "separator": [1537],
        "lastSelectedDay": [1537, "last-selected-day"],
        "eventData": [16],
        "calendarHeight": [513, "calendar-height"],
        "settingsSelectData": [1040],
        "parentOverlayContainerSelector": [513, "parent-overlay-container-selector"],
        "dataTestSuffix": [520, "data-test-suffix"],
        "hasSeparatorSettings": [516, "has-separator-settings"],
        "hasDateFormatSettings": [516, "has-date-format-settings"],
        "keepMouseFocus": [516, "keep-mouse-focus"],
        "namespaceI18n": [8, "namespace-i-1-8n"],
        "i18nKeys": [16],
        "activeCalendar": [32],
        "radioLabel": [32],
        "settingsLabel": [32],
        "calendarLabel": [32],
        "separatorLabel": [32]
    }, [[0, "selectionChanged", "selectionChangedHandler"]], {
        "separator": ["separatorChangedHandler"],
        "lastSelectedDay": ["separatorChangedHandler"],
        "dateFormat": ["dateFormatChangedHandler"],
        "displayDateFormat": ["dateFormatChangedHandler"],
        "settingsSelectData": ["settingsSelectDataChangedHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bxf-calendar-settings", "bxf-icon", "bxf-radio", "bxf-radio-group", "bxf-select"];
    components.forEach(tagName => { switch (tagName) {
        case "bxf-calendar-settings":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BxfCalendarSettings);
            }
            break;
        case "bxf-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "bxf-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "bxf-radio-group":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "bxf-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { BxfCalendarSettings as B, defineCustomElement as d };
